import { DefineComponent } from 'vue';

export type DiscountConditionsPaths = {
    details: [Record<string, () => Promise<DefineComponent>>, string];
    form: [Record<string, () => Promise<DefineComponent>>, string];
};

const discountConditionsPaths: DiscountConditionsPaths[] = [
    {
        details: [
            import.meta.glob<DefineComponent>(
                '/vendor/kibokosrl/kiboko-backoffice-ecommerce/resources/js/Components/DiscountConditionsDetails/Components/DiscountConditionsDetails/**/*.vue',
            ),
            '/vendor/kibokosrl/kiboko-backoffice-ecommerce/resources/js/Components/DiscountConditionsDetails/',
        ],
        form: [
            import.meta.glob<DefineComponent>(
                '/vendor/kibokosrl/kiboko-backoffice-ecommerce/resources/js/Components/DiscountConditions/**/*.vue',
            ),
            '/vendor/kibokosrl/kiboko-backoffice-ecommerce/resources/js/Components/DiscountConditions/',
        ],
    },
];

export default discountConditionsPaths;
